import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useCargo = (defaultPageSize, isFetch) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    firstname: "",
    lastname: "",
    personal: "",
    email: "",
    mobile: ""
  });

  useUpdateEffect(() => {
    if (defaultPageSize > 0) {
      fetchList(); 
    }
    }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/cargo/list", filter)
      setItems(response.data.cargos);
      setTotal(response.data.total);
      return response.data.cargos
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 0
      };

      const response = await automobyApi.post("/cargo/all", requestData)
      setItems(response.data.cargos);
      setTotal(response.data.total);
      return response.data.cargos
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/cargo/create`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          if (error.response && error.response.data && error.response.data.message) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  };
  

  const search = async (cargo, count) => {
    try {
      const requestData = {
        cargo: cargo,
        count: count,
      };

      const response = await automobyApi.post("/cargo/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/cargo/update`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          if (error.response && error.response.data && error.response.data.message) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  };
  

   

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          cargo_id: id
        };
        const response = await automobyApi.post(`/cargo/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

 
  const updateLocal = async (cargo) => {
    setItems(items.map(item =>
      item.id === cargo.id ? cargo : item
    ));
  }
 


  const updateGreen = async (newData) => {
    try {
      const response = await automobyApi.post(`/cargo/update/green`, newData);
      return response.data;
    } catch (error) {
      console.error(error);
    } 
  }


  const uploadTitleFile = (invoice) => {
    return new Promise((resolve, reject) => {
            automobyApi
            .post("/cargo/title/upload/", invoice)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                console.error(error);
                reject(error);
            });
    });
  };
    
   


  const cargoService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    updateGreen: updateGreen,
    uploadTitleFile:uploadTitleFile,
    remove: remove 
  };

  return { cargoService };
}